module.exports = __webpack_public_path__ + "img/pdd.74e980df.png";